import Education from '../assets/education.jpg';
import Health from '../assets/health.png';
import Food from '../assets/food.png'
import Home from '../assets/home.png';
import Clothe from '../assets/clothes.jpg'

const CardData = [
    { 
        type: 'image',
        src: Education,
        code: 'LHIr1,b0E2_29w-:s8a~_4ofs+M|',
        heading:'Donation for',
        text: 'Donation for Education'
      },
      {
        type: 'image',
        src: Health,
        heading:'Donation for',
        code: 'LfPskysApxW;-;ayRjfQp{bbMdjZ',
        text: 'Donation for Health'
      },
      {
        type: 'image',
        src: Home,
        code: 'LUPGpd%OIW-:-:M_Wpn$_4awW9M|',
        heading:'Donation for',
        text: 'Donation for Shelter'
      },
      {
        type: 'image',
        src: Food,
        code: 'LePr,yof~Vsp-fj[I^oL?ajaMxW.',
        heading:'Donation for',
        text: 'Donation for Food'
      },
      {
        type: 'image',
        src: Clothe,
        code: 'LqOMmVRi-;V@_NogNHfk%hWCMxof',
        heading:'Donation for',
        text: 'Donation for Clothes'
      },
];

export default CardData;
